import type { LanguageCode } from "config/languages";
import getDomainFromLanguage from "utils/getDomainFromLanguage";
import { getParentLanguage } from "utils/localeUtils";
import type { Hreflang } from "./index.d";

const formatLink = (link: string): string => {
  if (!link) return null;

  const linkWithTrailingSlash = link.endsWith("/") ? link : `${link}/`;
  return link.startsWith("/") ? linkWithTrailingSlash : `/${linkWithTrailingSlash}`;
};

const getLinkFromHreflangs = (language: LanguageCode, hreflangs: Record<string, Hreflang>) => {
  const currentUrl = hreflangs[language]?.href;
  if (!currentUrl) return null;

  const parentLanguage = getParentLanguage(language);

  if (parentLanguage === "en") {
    const enIntUrl = hreflangs["en-int"]?.href;
    return enIntUrl ?? currentUrl;
  }

  if (language === parentLanguage) return currentUrl;

  const parentUrl = hreflangs[parentLanguage]?.href;
  return parentUrl ?? currentUrl;
};

const createCanonical = (language: LanguageCode, hreflangs: Record<string, Hreflang>) => {
  const link = getLinkFromHreflangs(language, hreflangs);
  const domain = getDomainFromLanguage(language);

  return link ? `${domain}${formatLink(link)}` : null;
};

export default createCanonical;
